import DemoMethods from './DemoMethods';

export default DemoMethods;
